/* ============================================================
   PiPi Tea — /ppch/of order form
   Bundle selection · subscribe toggle · live order summary ·
   coupon · countdown · checkout hand-off.
   Shipping + payment are collected by Shopify checkout (this page
   captures the bundle choice + email only). Vanilla JS, no
   dependencies. One IIFE per .ppch-of root.
   ============================================================ */
(function () {
  'use strict';

  function money(n, sym) {
    sym = sym || '$';
    var v = (Math.round((Number(n) || 0) * 100) / 100).toFixed(2);
    return sym + v;
  }

  /* H2 — build a single order-summary row using DOM APIs (no innerHTML with user data) */
  function buildRow(imgSrc, qtyText, nameText, offText, priceText) {
    var row = document.createElement('div');
    row.className = 'ppch-os__row';

    var imgWrap = document.createElement('div');
    imgWrap.className = 'ppch-os__img';

    /* validate image src: allow relative paths and http/https URLs only */
    var safeImg = /^(https?:\/\/|\/)/i.test(imgSrc) ? imgSrc : null;
    if (safeImg) {
      var img = document.createElement('img');
      img.src = safeImg;
      img.alt = '';
      imgWrap.appendChild(img);
    }

    var qtySpan = document.createElement('span');
    qtySpan.className = 'qty';
    var qtyNum = Number(qtyText);
    qtySpan.textContent = isFinite(qtyNum) ? String(qtyNum) : '1';
    imgWrap.appendChild(qtySpan);

    var nameDiv = document.createElement('div');
    nameDiv.className = 'ppch-os__name';
    nameDiv.textContent = nameText;

    if (offText) {
      var offNum = parseFloat(offText);
      if (isFinite(offNum)) {
        var small = document.createElement('small');
        small.textContent = offNum + '% off';
        nameDiv.appendChild(small);
      }
    }

    var priceDiv = document.createElement('div');
    priceDiv.className = 'ppch-os__price';
    priceDiv.textContent = priceText;

    row.appendChild(imgWrap);
    row.appendChild(nameDiv);
    row.appendChild(priceDiv);

    return row;
  }

  function init(root) {
    /* M6 — idempotency guard */
    if (root.getAttribute('data-ppch-initialized')) return;
    root.setAttribute('data-ppch-initialized', '1');

    var sym = root.getAttribute('data-currency') || '$';
    var expeditedPrice = parseFloat(root.getAttribute('data-expedited-price') || '9.99');
    var expeditedVariant = root.getAttribute('data-expedited-variant') || '';
    var expeditedImg = root.getAttribute('data-expedited-image') || '';

    /* H3 — read coupons from embedded <script type="application/json">.
       Accepts a flat array [{code,type,value},…] (avoids nested-brace
       "}}" sequences Shopify rejects in stored settings) and normalises
       it to a code-keyed map. A legacy object map is still accepted. */
    var coupons = {};
    try {
      var couponScript = root.querySelector('script[data-ppch-coupons]');
      if (couponScript) {
        var parsed = JSON.parse(couponScript.textContent) || {};
        if (Array.isArray(parsed)) {
          parsed.forEach(function (c) {
            if (c && c.code) coupons[String(c.code).toUpperCase()] = c;
          });
        } else {
          coupons = parsed;
        }
      }
    } catch (e) {
      coupons = {};
    }

    var bundles = Array.prototype.slice.call(root.querySelectorAll('[data-bundle]'));
    var radios = Array.prototype.slice.call(root.querySelectorAll('input[name="ppch-bundle"]'));
    var subToggle = root.querySelector('[data-subscribe]');
    var expedited = root.querySelector('[data-expedited]');
    var osItems = root.querySelector('[data-os-items]');
    var osSummary = root.querySelector('.ppch-os');

    var appliedDiscount = null; // {code, type:'percent'|'amount', value}

    function bindSelectionButtons(items) {
      items.forEach(function (item, index) {
        var radio = item.querySelector('.ppch-pl__radio');
        if (!radio) return;
        radio.hidden = true;
        item.tabIndex = 0;
        item.setAttribute('role', 'button');
        function select() {
          if (radio.disabled) return;
          if (!radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            render();
          }
        }
        item.addEventListener('click', function (event) {
          if (event.target !== radio) select();
        });
        item.addEventListener('keydown', function (event) {
          var targetIndex = index;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') targetIndex = (index + items.length - 1) % items.length;
          else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') targetIndex = (index + 1) % items.length;
          else if (event.key === 'Home') targetIndex = 0;
          else if (event.key === 'End') targetIndex = items.length - 1;
          else if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          var target = items[targetIndex];
          if (!target) return;
          target.focus();
          var targetRadio = target.querySelector('.ppch-pl__radio');
          if (targetRadio && !targetRadio.disabled) {
            targetRadio.checked = true;
            targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }

    function selectedBundle() {
      var checked = radios.filter(function (radio) { return radio.checked; })[0];
      if (!checked) return bundles[0];
      return bundles.filter(function (b) { return b.contains(checked); })[0] || bundles[0];
    }

    function isSub() { return root.classList.contains('is-subscribe'); }

    function bundleTotal(b) {
      return parseFloat(b.getAttribute(isSub() ? 'data-total-sub' : 'data-total-onetime') || '0');
    }

    function render() {
      var b = selectedBundle();
      if (!b) return;

      // highlight selected card
      bundles.forEach(function (x) {
        var selected = x === b;
        x.classList.toggle('is-selected', selected);
        x.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      var qty = b.getAttribute('data-qty') || '1';
      var name = b.getAttribute('data-name') || '';
      var img = b.getAttribute('data-image') || '';
      var unit = isSub() ? b.getAttribute('data-unit-sub') : b.getAttribute('data-unit-onetime');
      var suffix = b.getAttribute('data-suffix') || '';
      var off = isSub() ? b.getAttribute('data-off-sub') : b.getAttribute('data-off-onetime');
      var lineTotal = bundleTotal(b);

      /* H2 — build rows using DOM APIs, not innerHTML string concatenation */
      var unitNum = parseFloat(unit);
      var priceText = isFinite(unitNum) ? money(unitNum, sym) + suffix : money(0, sym);
      var mainRow = buildRow(img, qty, name, off, priceText);

      var subtotal = lineTotal;

      if (osItems) {
        /* clear existing rows safely */
        while (osItems.firstChild) { osItems.removeChild(osItems.firstChild); }
        osItems.appendChild(mainRow);

        if (expedited && expedited.checked) {
          subtotal += expeditedPrice;
          var expRow = buildRow(expeditedImg, '1', 'Expedited Shipping', null, money(expeditedPrice, sym));
          osItems.appendChild(expRow);
        }
      }

      // discount
      var discountAmt = 0;
      if (appliedDiscount) {
        discountAmt = appliedDiscount.type === 'percent'
          ? subtotal * (appliedDiscount.value / 100)
          : Math.min(appliedDiscount.value, subtotal);
      }
      var total = Math.max(0, subtotal - discountAmt);

      set(root, '[data-os-subtotal]', money(subtotal, sym));
      var discRow = root.querySelector('[data-os-discount-row]');
      if (discRow) {
        discRow.classList.toggle('is-hidden', !appliedDiscount);
        set(root, '[data-os-discount]', '-' + money(discountAmt, sym));
        /* M4 — label discount as estimated */
        var lbl = root.querySelector('[data-os-discount-label]');
        if (lbl && appliedDiscount) lbl.textContent = 'Discount (' + appliedDiscount.code + ') — estimated';
      }
      // header + grand totals
      Array.prototype.forEach.call(root.querySelectorAll('[data-os-total]'), function (el) {
        el.textContent = money(total, sym);
      });
    }

    function set(scope, sel, val) {
      var el = scope.querySelector(sel);
      if (el) el.textContent = val;
    }

    function clickOnEnter(event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      event.currentTarget.click();
    }

    /* ---- subscribe toggle ---- */
    if (subToggle) {
      root.classList.toggle('is-subscribe', subToggle.checked);
      subToggle.addEventListener('change', function () {
        root.classList.toggle('is-subscribe', subToggle.checked);
        render();
      });
      subToggle.addEventListener('keydown', clickOnEnter);
    }

    /* ---- bundle radios ---- */
    if (!radios.some(function (radio) { return radio.checked; })) {
      var firstRadio = radios.filter(function (radio) { return !radio.disabled; })[0];
      if (firstRadio) firstRadio.checked = true;
    }
    bindSelectionButtons(bundles);
    radios.forEach(function (r) { r.addEventListener('change', render); });

    /* ---- expedited bump ---- */
    if (expedited) expedited.addEventListener('change', render);

    /* ---- order summary collapse (M7 — set aria-expanded on button toggle) ---- */
    var osHead = root.querySelector('[data-os-toggle]');
    if (osHead && osSummary) {
      osHead.addEventListener('click', function () {
        var isOpen = osSummary.classList.toggle('is-open');
        /* M7 — sync aria-expanded */
        osHead.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    /* ---- coupon ---- */
    var couponInput = root.querySelector('[data-coupon-input]');
    var couponBtn = root.querySelector('[data-coupon-apply]');
    var couponMsg = root.querySelector('[data-coupon-msg]');
    if (couponBtn) {
      couponBtn.addEventListener('click', function () {
        var code = (couponInput.value || '').trim().toUpperCase();
        if (!code) return;
        if (coupons[code]) {
          appliedDiscount = {
            code: code,
            type: coupons[code].type || 'percent',
            value: coupons[code].value || 0
          };
          if (couponMsg) { couponMsg.textContent = 'Code "' + code + '" applied!'; couponMsg.className = 'ppch-os__discount-msg is-ok'; }
        } else {
          appliedDiscount = null;
          if (couponMsg) { couponMsg.textContent = 'Invalid discount code.'; couponMsg.className = 'ppch-os__discount-msg is-error'; }
        }
        render();
      });
    }

    /* ---- countdown timer ---- */
    var timer = root.querySelector('[data-timer]');
    if (timer) {
      var secs = parseInt(timer.getAttribute('data-timer'), 10) || 600;
      (function tick() {
        var m = Math.floor(secs / 60), s = secs % 60;
        timer.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
        if (secs > 0) { secs--; setTimeout(tick, 1000); }
      })();
    }

    /* ---- complete purchase → cart + checkout hand-off (M5 — resilient with snapshot/restore) ---- */
    var cta = root.querySelector('[data-complete]');
    if (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        var b = selectedBundle();
        var variant = isSub() ? b.getAttribute('data-variant-sub') : b.getAttribute('data-variant-onetime');
        var sellingPlan = isSub() ? b.getAttribute('data-selling-plan') : '';

        if (!variant) {
          alert('This bundle is not yet linked to a Shopify product variant. Add the variant IDs in the theme editor to enable checkout.');
          return;
        }

        var items = [];
        var qty = parseInt(b.getAttribute('data-qty'), 10) || 1;
        var line = { id: Number(variant), quantity: qty };
        if (sellingPlan) line.selling_plan = Number(sellingPlan);
        items.push(line);
        if (expedited && expedited.checked && expeditedVariant) {
          items.push({ id: Number(expeditedVariant), quantity: 1 });
        }

        // capture the email as a cart attribute (Shopify collects shipping + payment at checkout)
        var attrs = {};
        var emailField = root.querySelector('[name="emailAddress"]');
        if (emailField && emailField.value) attrs.emailAddress = emailField.value;

        cta.style.opacity = '0.7';
        cta.style.pointerEvents = 'none';

        function enableCta(msg) {
          cta.style.opacity = '';
          cta.style.pointerEvents = '';
          if (msg) alert(msg);
        }

        /* M5 — snapshot existing cart before clearing */
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            /* build restore payload from snapshot */
            var snapshotItems = (cart.items || []).map(function (item) {
              var entry = { id: item.variant_id, quantity: item.quantity };
              if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
                entry.selling_plan = item.selling_plan_allocation.selling_plan.id;
              }
              if (item.properties && Object.keys(item.properties).length) {
                entry.properties = item.properties;
              }
              return entry;
            });

            return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
              .then(function () {
                return fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ items: items, attributes: attrs })
                });
              })
              .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
              .then(function (res) {
                if (!res.ok) {
                  var errMsg = res.j && res.j.description ? res.j.description : 'Add to cart failed';
                  /* M5 — attempt to restore snapshot on failure */
                  var restorePromise = snapshotItems.length
                    ? fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ items: snapshotItems })
                      })
                    : Promise.resolve();
                  return restorePromise.then(function () {
                    enableCta('Sorry, we could not add your items to the cart: ' + errMsg + '\nPlease try again.');
                  }, function () {
                    enableCta('Sorry, we could not add your items to the cart: ' + errMsg + '\nPlease try again.');
                  });
                }
                var url = '/checkout';
                if (appliedDiscount) url += '?discount=' + encodeURIComponent(appliedDiscount.code);
                window.location.href = url;
              });
          })
          .catch(function (err) {
            enableCta('Sorry, we could not start checkout: ' + err.message + '\nPlease try again.');
          });
      });
    }

    render();
  }

  function boot() {
    /* M6 — skip already-initialized roots */
    Array.prototype.forEach.call(document.querySelectorAll('.ppch-of'), function (root) {
      if (!root.getAttribute('data-ppch-initialized')) {
        init(root);
      }
    });
  }

  /* M6 — theme editor support: re-run boot when a section is added/reloaded */
  document.addEventListener('shopify:section:load', boot);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
